import { Component, inject, input, linkedSignal, OnDestroy, OnInit, output } from '@angular/core';

import { UiCoreModule } from '@softline/ui-core';
import { SOFTLINE_CONFIG_DEFAULT_DEBOUNCE_TIME } from '../../../application.shared';
import { SearchOptions } from '@softline/core';
import { debounceTime, Subject, Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'soft-search-input',
    imports: [UiCoreModule],
    templateUrl: './search-input.component.html',
    styleUrl: './search-input.component.css'
})
export class SearchInputComponent implements OnInit, OnDestroy {
  private subscription?: Subscription;
  private _debounceTime: number = inject(SOFTLINE_CONFIG_DEFAULT_DEBOUNCE_TIME);
  private searchTermChanged$ = new Subject<string>();

  searchTermInput = input<string>('', {alias: 'searchTerm'})
  searchTerm = linkedSignal<string>(() => this.searchTermInput());
  searchTermChange = output<string>();

  optionsInput = input<SearchOptions>({ caseSensitive: false, wholeWord: false, regex: false }, {alias: 'options'})
  options = linkedSignal<SearchOptions>(() => this.optionsInput());
  optionsChange = output<SearchOptions>();

  debounceTime = input<number>(this._debounceTime);
  debouncedSearchTermChange = output<string>();

  constructor() {
  }

  ngOnInit(): void {
    this.subscription = this.searchTermChanged$.pipe(
      debounceTime(this.debounceTime()),
      distinctUntilChanged()
    ).subscribe(o => this.debouncedSearchTermChange.emit(o))
  }

  ngOnDestroy(): void {
    if(this.subscription && !this.subscription.closed)
      this.subscription.unsubscribe();
    this.subscription = undefined;
  }

  onInput(searchTerm: string): void {
    this.searchTerm.set(searchTerm);
    this.searchTermChanged$.next(searchTerm);
  }

  onOptionsClick(key: keyof SearchOptions) {
    const options = { ...this.options(), [key]: !this.options()[key] };
    this.options.set(options);
    this.optionsChange.emit(options)
  }
}
